import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerService from "../../../Customer/Controller/CustomerController";
import Draggable from 'react-draggable';
import OppurtunityService from "../../../Oppurtunity/Controller/OppurtunityController";
import CreateCustomerModal from "../../../Customer/View/CreateCustomer";
import OppurtunityDetailModal from "../../../Oppurtunity/Views/OppurtunityDetail";
function CustomerSelectionModal({ show, onClose, onSelectCustomer }) {
    const { theme } = useContext(ThemeContext);
    const tableRef = useRef();
    const navigate = useNavigate();

    const [CustomerList, setCustomer] = useState([]);
    const [OpportunityList, setOpportunityList] = useState([]);
    const [clientType, setClientType] = useState("1"); // Default Customer
    const [loading, setLoading] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const [newlyCreatedID, setNewlyCreatedID] = useState(null);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }

        console.log('Initializing DataTable...');
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };
    // Fetch Customers
    const fetchCustomers = async () => {
        debugger;
        setLoading(true);
        try {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                console.log('Destroying existing DataTable instance...');
                $(tableRef.current).DataTable().destroy();
            }
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomersForQuotation(redirectCallback);
            setCustomer(listOfCustomers || []);
            return listOfCustomers;
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch Opportunities
    const fetchOpportunities = async () => {
        debugger;
        setLoading(true);
        try {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                console.log('Destroying existing DataTable instance...');
                $(tableRef.current).DataTable().destroy();
            }
            const redirectCallback = () => navigate('/');
            const oppurtunityData = await OppurtunityService.GetAllOpportunityForQuotations(redirectCallback);
            setOpportunityList(oppurtunityData || []);
            return oppurtunityData;

        } catch (error) {
            console.error('Error fetching opportunities:', error);
        } finally {
            setLoading(false);
        }
    };

    // Load data on modal open or clientType change
    useEffect(() => {
        if (!show) return;

        if (clientType === "1") {
            fetchCustomers();
        } else {
            fetchOpportunities();
        }
    }, [show, clientType]);

    // Safe DataTable initialization after data changes
    useEffect(() => {
        const dataList = clientType === "1" ? CustomerList : OpportunityList;
        if (dataList.length > 0) {
            console.log('Company list updated, initializing DataTable with data:', dataList);
            initDataTable();
        }

    }, [CustomerList, OpportunityList, clientType]);




    const handleRadioChange = (event) => {
        const value = event.target.value;
        setClientType(value);
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }
        // Clear old data before fetching new
        setCustomer([]);
        setOpportunityList([]);
    };

    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const handleStart = (e) => e.stopPropagation();

    const dataList = clientType === "1" ? CustomerList : OpportunityList;


    const handleAddNew = () => {

        if (clientType === "1") {
            setIsOpportunityModalOpen(false);
            setIsCustomerModalOpen(true);
        }
        else {
            setIsCustomerModalOpen(false);
            setIsOpportunityModalOpen(true);
        }
    };

    // Handle modal close and refresh customer list
    const handleCloseModal = async (ClientCompanyID) => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        let dataList = [];
        setIsOpportunityModalOpen(false);
        setIsCustomerModalOpen(false);

        if (!ClientCompanyID) return;

        // Store the new ID
        setNewlyCreatedID(ClientCompanyID);

        // Fetch the updated list
        if (clientType === "1") {
            dataList = await fetchCustomers();
        } else {
            dataList = await fetchOpportunities();
        }
        debugger;
        const newItem = dataList.filter(item => item.ClientCompanyID.toString() === ClientCompanyID.toString());


        if (newItem.length > 0) {
            onSelectCustomer(newItem[0]);

        }
    };


    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable
                    handle=".modal-content"
                    onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,p"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Company</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>

                        <div className="modal-body" style={{ "maxHeight": "400px", "overflow": "auto" }}>
                            {/* Radio Buttons */}
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <td style={{ width: "5%" }}>
                                        <label htmlFor="Type" style={{ float: "right" }}></label>
                                    </td>
                                    <td style={{ width: "45%" }}>

                                        <table style={{ width: "100%" }}>
                                            <tr>
                                                <td>
                                                    <table style={{ width: "100%" }}>
                                                        <tr>
                                                            <td>
                                                                <input type="radio" name="ClientType" value="1" checked={clientType === "1"} onChange={handleRadioChange} />
                                                            </td>
                                                            <td>
                                                                <label className="col-form-label">Customer</label>
                                                            </td>


                                                            <td>
                                                                <input type="radio" name="ClientType" value="0" checked={clientType === "0"} onChange={handleRadioChange} />
                                                            </td>
                                                            <td>
                                                                <label className="col-form-label"> Opportunity</label>
                                                            </td>



                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>

                                    </td>
                                    <td style={{ width: "5%" }}>

                                    </td>
                                    <td style={{ width: "45%", float: "right" }}>
                                        <button style={{ background: "#00796B" }} type="button" className={`btn btn-primary`} onClick={handleAddNew}>
                                            <i className="icofont-plus" aria-hidden="true">Add New</i>
                                        </button>
                                    </td>

                                </tr>
                            </table>




                            {/* Loading indicator */}

                            {loading && (
                                <div class="loading">
                                    <div class="d-table">
                                        <div class="d-tablecell">
                                            <span class="loader">
                                                <span class="loader-inner"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Table */}
                            {!loading && dataList.length > 0 && (
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card mb-30">
                                            <div className="card-body">
                                                <div className="table-responsive"></div>
                                                <table className="table table-striped" ref={tableRef} style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Company</th>
                                                            <th>Town/City</th>
                                                            <th>Post Code</th>
                                                            <th>Telephone</th>
                                                            <th>Type</th>
                                                            <th>Status</th>
                                                            <th>Website</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dataList.map(item => (
                                                            <tr
                                                                key={item.ClientCompanyID}
                                                                onClick={() => onSelectCustomer(item)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <td>{truncateText(item.CompanyName)}</td>
                                                                <td>{truncateText(item.City)}</td>
                                                                <td>{truncateText(item.Postcode)}</td>
                                                                <td>{truncateText(item.Phone1)}</td>
                                                                <td>{truncateText(item.CType)}</td>
                                                                <td>{truncateText(item.vc_AccountStatus)}</td>
                                                                <td>{truncateText(item.Website)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {isCustomerModalOpen && (
                            <CreateCustomerModal
                                ClientCompanyID="0"
                                onClose={handleCloseModal}
                                onSuccess={fetchCustomers} // Refresh customers on success
                                IsCustomerSelection="1"
                            />
                        )}
                        {isOpportunityModalOpen && (
                            <OppurtunityDetailModal OpportunityID="0" onClose={handleCloseModal} onSuccess={fetchOpportunities} IsDiaries={"0"} CommunicationID={"0"}
                                onNext="" onPrevious="" IsCustomerSelection="1" />
                        )}
                    </div>
                </Draggable>
            </div>

        </div>
    );
}

export default CustomerSelectionModal;